$(document).ready(function () {


  // media queries
  const mq = [
    window.matchMedia("(max-width: 767px)"),
    window.matchMedia("(min-width: 768px) and (max-width: 1279px)"),
    window.matchMedia("(min-width: 1280px)")
  ];


  // resize events
  let current;

  $(window).on("resize", function () {
    // positioning elements
    if (current !== "mobile" && mq[0].matches) {

      $(".pages").insertBefore($(".aside"));
      current = "mobile";

    } else if (current !== "tablet" && mq[1].matches) {

      $(".pages").insertAfter($(".aside"));
      current = "tablet";

    } else if (current !== "desktop" && mq[2].matches) {

      $(".pages").insertAfter($(".aside"));
      current = "desktop";

    }
  }).trigger("resize");


  // drop open and hide when click outside
  const
    links = ".dropdown-link-js",
    innerElements = ".dropdown-js",
    addMenuClass = function () {
      $("body").addClass("open_menu");
    },
    removeMenuClass = function () {
      $("body").removeClass("open_menu");
    };

  $(document).on("click", links, function (e) {
    if ($(this).hasClass("active")) {
      $(links).filter('a[href="' + this.hash + '"]').removeClass("active");
      $(innerElements).filter(this.hash).removeClass("open");
    } else {
      $(links).removeClass("active").filter('a[href="' + this.hash + '"]').addClass("active");
      $(innerElements).removeClass("open").filter(this.hash).addClass("open");
      $(links).add(innerElements).off();
    }
    if ($(this).hasClass("nav-js")) {
      if ($(this).hasClass("active")) {
        addMenuClass();
      } else {
        removeMenuClass();
      }
    }
    e.preventDefault();
  }).on("mouseup touchstart keyup", function (e) {
    if ((!$(links).add(innerElements).is(e.target) && $(links).add(innerElements).has(e.target).length === 0) || e.keyCode === 27) {
      $(links).removeClass("active");
      $(innerElements).removeClass("open");
      removeMenuClass();
    }
  });


  // scroll to
  $(document).on("click", ".scroll-to-js", function (e) {
    const targetDiv = $(this).attr("href");
    $("html, body").animate({
      scrollTop: $(targetDiv).offset().top
    }, 1000);
    e.preventDefault();
  });


  // floating labels
  $(document).on("focusout focusin", 'input:not([type="checkbox"]):not([type="radio"]), textarea', function (e) {
    if (e.type === "focusout") {
      if ($(this).val() === "") {
        $("label[for='" + $(this).attr('id') + "']").removeClass("active-js");
      } else {
        $("label[for='" + $(this).attr('id') + "']").addClass("active-js");
      }
    } else if (e.type === "focusin") {
      if ($(this).val() === "") {
        $("label[for='" + $(this).attr('id') + "']").addClass("active-js");
      }
    }
  });


  // sliders
  if ($.fn.slick) {
    const
      teamSlider = $(".team-slider-js"),
      problemsSlider = $(".problems-slider-js");

    teamSlider.slick({
      dots: false,
      autoplay: false,
      infinite: true,
      variableWidth: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow-right" aria-hidden="true"></i></button>'
    });

    problemsSlider.on("init reInit afterChange", function (event, slick, currentSlide) {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $(".problems_slider__pager").html('<span class="current">' + i + '</span> <span class="sep">/</span> ' + slick.slideCount);
    });

    problemsSlider.slick({
      dots: false,
      autoplay: false,
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="icon-arrow-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="icon-arrow-right" aria-hidden="true"></i></button>',
      slide: ".problems_slider__panels"
    });
  }


  // form validation
  if ($.fn.validate) {
    $(".contact-form-js").validate({
      errorPlacement: function () {
        return false;
      }
    });
    $(".comments-form-js").validate({
      errorPlacement: function () {
        return false;
      }
    });
  }

  // sticky
  if ($.fn.stick_in_parent) { // jshint ignore:line
    let currentSticky;

    const
      sticky = ".share",
      stickyOptions = {
        offset_top: 20 // jshint ignore:line
      };

    $(window).on("resize", function () {
      if (currentSticky !== "desktop" && !mq[0].matches) {

        $(sticky).stick_in_parent(stickyOptions); // jshint ignore:line

        currentSticky = "desktop";

      } else if (currentSticky !== "else" && mq[0].matches) {

        $(sticky).trigger("sticky_kit:detach");
        currentSticky = "else";

      }
    }).trigger("resize");
  }


  // animation
  $(".welcome__author").appear().one("appear", function () {

    new TimelineLite()
      .to(".welcome__deco-2", 0.8, { rotation: "-180deg" }, "0.2")
      .fromTo(".welcome__deco-3", 0.5, { autoAlpha: 0, scale: 0.5 }, { autoAlpha: 1, scale: 1, rotation: "120deg" }, "0.2")
      .add(function () {
        TweenLite.set(".draw-svg", { visibility: "visible" });
        anime({
          targets: ".draw-svg",
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: "easeInOutSine",
          duration: 1500,
          direction: "alternate",
          loop: false,
          complete: function () {
            new TimelineLite()
              .to(".draw-svg", 0.4, { fill: "#fff", stroke: "none" });
          }
        });
      })
      .to(".welcome__deco-1, .welcome__deco-5", 0.5, { scale: 1.2 })
      .to(".welcome__deco-1, .welcome__deco-5", 0.5, { scale: 1 })
      .to(".welcome__deco-6", 2, { rotation: "360deg", autoAlpha: 0 }, "a1")
      .to(".welcome__deco-6", 2, { rotation: "-360deg", autoAlpha: 1 })
      .fromTo(".welcome__deco-4", 1, { autoAlpha: 0, scale: 0.5 }, { autoAlpha: 1, scale: 1, ease: Back.easeOut.config(1.7) }, "a1+=1")
      .fromTo(".welcome__deco-7", 1, { autoAlpha: 0, transform: "translateY(50px)" }, { autoAlpha: 1, transform: "translateY(0)" }, 0);

  });


  // animation on load
  $.force_appear(); // jshint ignore:line


  // animation on scroll
  AOS.init({
    once: true
  });


  // table responsive
  $(".post__body table:not([class])").each(function () {
    while (this.attributes.length > 0) {
      this.removeAttribute(this.attributes[0].name);
    }
    $(this).wrapAll('<div class="table-responsive"></div>');
  });


});
